<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-title" id="fm-1"><a id="page_viii">Abbreviations</a></h1><a id="page_viii">
<table>
<tbody>
<tr>
<td><p class="tabtitle">General</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left">ET</p></td>
<td class="wid75"><p class="t-hang">English Translation</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left">IF</p></td>
<td class="wid75"><p class="t-hang">Introductory Formula</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left">MS(S)</p></td>
<td class="wid75"><p class="t-hang">Manuscript(s)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left">LXX</p></td>
<td class="wid75"><p class="t-hang">Septuagint (A = Alexandrinus; B = Vaticanus)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left">MT</p></td>
<td class="wid75"><p class="t-hang">Masoretic Text</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>Str-Bil</em></p></td>
<td class="wid75"><p class="t-hang"><em>Kommentar zum Neuen Testament aus Talmud und Midrasch</em>, 5 vols., H. L. Strack and P. Billerbeck [1922-56]. Munich: Beck, 1961-63.</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>TDNT</em></p></td>
<td class="wid75"><p class="t-hang"><em>Theological Dictionary of the New Testament,</em> 9 vols., ed. G. Kittel and G. Friedrich [1932ff.], tr. G. W. Bromiley. Grand Rapids: Eerdmans, 1964-74.</p></td>
</tr>
</tbody>
</table>
<p class="tabtitle">Journals</p>
<table>
<tbody>
<tr>
<td class="wid20"><p class="t-left"><em>ALUOS</em></p></td>
<td class="wid75"><p class="t-hang"><em>Annual of Leeds University Oriental Society</em> (Leeds)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>AusBR</em></p></td>
<td class="wid75"><p class="t-hang"><em>Australian Biblical Review</em> (Melbourne)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>BA</em></p></td>
<td class="wid75"><p class="t-hang"><em>Biblical Archaeologist</em> (New Haven — Ann Arbor — Philadelphia)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>BASOR</em></p></td>
<td class="wid75"><p class="t-hang"><em>Bulletin of the American Schools of Oriental Research</em> (Cambridge)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>BBR</em></p></td>
<td class="wid75"><p class="t-hang"><em>Bulletin for Biblical Research</em> (Winona Lake)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>Bib</em></p></td>
<td class="wid75"><p class="t-hang"><em>Biblica</em> (Rome)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>BJRL</em></p></td>
<td class="wid75"><p class="t-hang"><em>Bulletin of the John Rylands Library</em> (Manchester)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>BR</em></p></td>
<td class="wid75"><p class="t-hang"><em>Biblical Research</em> (Chicago)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>BSac</em></p></td>
<td class="wid75"><p class="t-hang"><em>Bibliotheca Sacra</em> (Dallas)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><a id="page_ix"><em>BTB</em></a></p></td>
<td class="wid75"><p class="t-hang"><em>Biblical Theology Bulletin</em> (St. Bonaventure)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>BZ</em></p></td>
<td class="wid75"><p class="t-hang"><em>Biblische Zeitschrift</em> (Freiburg — Paderborn)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>CBQ</em></p></td>
<td class="wid75"><p class="t-hang"><em>Catholic Biblical Quarterly</em> (Washington)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>CJT</em></p></td>
<td class="wid75"><p class="t-hang"><em>Canadian Journal of Theology</em> (Toronto)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>CS</em></p></td>
<td class="wid75"><p class="t-hang"><em>Cahiers Sioniens</em> (Paris)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>CTJ</em></p></td>
<td class="wid75"><p class="t-hang"><em>Calvin Theological Journal</em> (Grand Rapids)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>CTM</em></p></td>
<td class="wid75"><p class="t-hang"><em>Concordia Theological Monthly</em> (St. Louis)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>DBSup</em></p></td>
<td class="wid75"><p class="t-hang"><em>Dictionnaire de la Bible, Supplément</em> (Paris)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>ETL</em></p></td>
<td class="wid75"><p class="t-hang"><em>Ephemerides Theologicae Lovanienses</em> (Louvain — Leuven)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>EvQ</em></p></td>
<td class="wid75"><p class="t-hang"><em>Evangelical Quarterly</em> (Manchester — Aberdeen)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>ExpT</em></p></td>
<td class="wid75"><p class="t-hang"><em>Expository Times</em> (Banstead)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>HTR</em></p></td>
<td class="wid75"><p class="t-hang"><em>Harvard Theological Review</em> (Cambridge)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>HUCA</em></p></td>
<td class="wid75"><p class="t-hang"><em>Hebrew Union College Annual</em> (Cincinnati)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>IEJ</em></p></td>
<td class="wid75"><p class="t-hang"><em>Israel Exploration Journal</em> (Jerusalem)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>IJT</em></p></td>
<td class="wid75"><p class="t-hang"><em>Indian Journal of Theology</em> (Calcutta)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>Int</em></p></td>
<td class="wid75"><p class="t-hang"><em>Interpretation</em> (Richmond)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>JAOS</em></p></td>
<td class="wid75"><p class="t-hang"><em>Journal of the American Oriental Society</em> (New Haven)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>JBL</em></p></td>
<td class="wid75"><p class="t-hang"><em>Journal of Biblical Literature</em> (Philadelphia — Missoula — Chico — Decatur)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>JETS</em></p></td>
<td class="wid75"><p class="t-hang"><em>Journal of the Evangelical Theological Society</em> (Wheaton)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>JJS</em></p></td>
<td class="wid75"><p class="t-hang"><em>Journal of Jewish Studies</em> (London — Oxford)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>JQR</em></p></td>
<td class="wid75"><p class="t-hang"><em>Jewish Quarterly Review</em> (Philadelphia)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>JSJ</em></p></td>
<td class="wid75"><p class="t-hang"><em>Journal for the Study of Judaism</em> (Leiden)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>JSNT</em></p></td>
<td class="wid75"><p class="t-hang"><em>Journal for the Study of the New Testament</em> (Sheffield)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>JSOT</em></p></td>
<td class="wid75"><p class="t-hang"><em>Journal for the Study of the Old Testament</em> (Sheffield)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>JSS</em></p></td>
<td class="wid75"><p class="t-hang"><em>Journal of Semitic Studies</em> (Manchester)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>JTS</em></p></td>
<td class="wid75"><p class="t-hang"><em>Journal of Theological Studies</em> (Oxford)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>JTSA</em></p></td>
<td class="wid75"><p class="t-hang"><em>Journal of Theology for Southern Africa</em> (Rondebosch)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>LQHR</em></p></td>
<td class="wid75"><p class="t-hang"><em>London Quarterly and Holborn Review</em> (London)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>Neot</em></p></td>
<td class="wid75"><p class="t-hang"><em>Neotestamentica</em> (Pretoria)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>NovT</em></p></td>
<td class="wid75"><p class="t-hang"><em>Novum Testamentum</em> (Leiden)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>NRT</em></p></td>
<td class="wid75"><p class="t-hang"><em>La Nouvelle Revue Théologique</em> (Tournai)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>NTS</em></p></td>
<td class="wid75"><p class="t-hang"><em>New Testament Studies</em> (Cambridge)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>PAAJR</em></p></td>
<td class="wid75"><p class="t-hang"><em>Proceedings of the American Academy of Jewish Research</em> (New York)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>PIJSL</em></p></td>
<td class="wid75"><p class="t-hang"><em>Papers of the Institute of Jewish Studies, London</em> (London)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>RB</em></p></td>
<td class="wid75"><p class="t-hang"><em>Revue Biblique</em> (Paris — Jerusalem)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>RevQ</em></p></td>
<td class="wid75"><p class="t-hang"><em>Revue de Qumran</em> (Paris)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>RHPR</em></p></td>
<td class="wid75"><p class="t-hang"><em>Revue d’Histoire et de Philosophie Religieuses</em> (Strasbourg)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>RHR</em></p></td>
<td class="wid75"><p class="t-hang"><em>Revue de l’Histoire des Religions</em> (Paris)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>RSR</em></p></td>
<td class="wid75"><p class="t-hang"><em>Recherches de Science Religieuse</em> (Paris)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>ScEccl</em></p></td>
<td class="wid75"><p class="t-hang"><em>Sciences Ecclésiastiques</em> (Montreal)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>SEA</em></p></td>
<td class="wid75"><p class="t-hang"><em>Svensk Exegetisk Årsbok</em> (Uppsala)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>SJT</em></p></td>
<td class="wid75"><p class="t-hang"><em>Scottish Journal of Theology</em> (Edinburgh)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>ST</em></p></td>
<td class="wid75"><p class="t-hang"><em>Studia Theologica</em> (Lund — Aarhus — Oslo)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>TLZ</em></p></td>
<td class="wid75"><p class="t-hang"><em>Theologische Literaturzeitung</em> (Leipzig — Berlin)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><a id="page_x"><em>TS</em></a></p></td>
<td class="wid75"><p class="t-hang"><em>Theological Studies</em> (Washington)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>TynBul</em></p></td>
<td class="wid75"><p class="t-hang"><em>Tyndale Bulletin</em> (Cambridge)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>VoxT</em></p></td>
<td class="wid75"><p class="t-hang"><em>Vox Theologica</em> (Assen)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>VT</em></p></td>
<td class="wid75"><p class="t-hang"><em>Vetus Testamentum</em> (Leiden)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>VTSup</em></p></td>
<td class="wid75"><p class="t-hang"><em>Vetus Testamentum, Supplements</em> (Leiden)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>ZAW</em></p></td>
<td class="wid75"><p class="t-hang"><em>Zeitschrift für die Alttestamentliche Wissenschaft</em> (Berlin)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>ZNW</em></p></td>
<td class="wid75"><p class="t-hang"><em>Zeitschrift für die Neutestamentliche Wissenschaft</em> (Berlin)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>ZRT</em></p></td>
<td class="wid75"><p class="t-hang"><em>Zeitschrift für Religionswissenschaft und Theologie</em></p></td>
</tr>
<tr>
<td class="wid20"><p class="t-left"><em>ZTK</em></p></td>
<td class="wid75"><p class="t-hang"><em>Zeitschrift für Theologie und Kirche</em> (Freiburg — Tübingen)</p></td>
</tr>
</tbody>
</table>
<p class="tabtitle">Philo</p>
<table>
<tbody>
<tr>
<td class="wid20"><p class="t-hang"><em>De Abr</em></p></td>
<td class="wid75"><p class="t-hang"><em>De Abrahamo</em></p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>De Cherub</em></p></td>
<td class="wid75"><p class="t-hang"><em>De Cherubim</em></p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>De Decal</em></p></td>
<td class="wid75"><p class="t-hang"><em>De Decalogo</em></p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>De Exsecrat</em></p></td>
<td class="wid75"><p class="t-hang"><em>De Exsecrationibus</em></p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>De Fuga</em></p></td>
<td class="wid75"><p class="t-hang"><em>De Fuga et Inventione</em></p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>Leg All</em></p></td>
<td class="wid75"><p class="t-hang"><em>Legum Allegoriae</em></p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>De Migrat Abr</em></p></td>
<td class="wid75"><p class="t-hang"><em>De Migratione Abrahami</em></p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>De Mutat Nom</em></p></td>
<td class="wid75"><p class="t-hang"><em>De Mutatione Nominum</em></p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>De Plant</em></p></td>
<td class="wid75"><p class="t-hang"><em>De Plantatione</em></p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>De Post Cain</em></p></td>
<td class="wid75"><p class="t-hang"><em>De Posteritate Caini</em></p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>De Prof</em></p></td>
<td class="wid75"><p class="t-hang"><em>De Profugis</em></p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>Quaes et Sol Gen</em></p></td>
<td class="wid75"><p class="t-hang"><em>Quaestiones et Solutiones in Genesin</em></p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>Quaes et Sol Exod</em></p></td>
<td class="wid75"><p class="t-hang"><em>Quaestiones et Solutiones in Exodum</em></p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>Quis Rer Div Heres</em></p></td>
<td class="wid75"><p class="t-hang"><em>Quis Rerum Divinarum Heres Sit</em></p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>Quod Det Pot Insid</em></p></td>
<td class="wid75"><p class="t-hang"><em>Quod Deterius Potiori Insidiari Soleat</em></p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>Quod Deus Immut</em></p></td>
<td class="wid75"><p class="t-hang"><em>Quod Deus Sit Immutabilis</em></p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>Quod Omnis Prob Liber</em></p></td>
<td class="wid75"><p class="t-hang"><em>Quod Omnis Probus Liber Sit</em></p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>De Sacrif Ab et Cain</em></p></td>
<td class="wid75"><p class="t-hang"><em>De Sacrificiis Abelis et Caini</em></p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>De Somn</em></p></td>
<td class="wid75"><p class="t-hang"><em>De Somniis</em></p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>De Spec Leg</em></p></td>
<td class="wid75"><p class="t-hang"><em>De Specialibus Legibus</em></p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>De Vita Mos</em></p></td>
<td class="wid75"><p class="t-hang"><em>De Vita Mosis</em></p></td>
</tr>
</tbody>
</table>
<p class="tabtitle">Dead Sea Scrolls</p>
<table>
<tbody>
<tr>
<td class="wid20"><p class="t-hang"><em>1QS</em></p></td>
<td class="wid75"><p class="t-hang">Manual of Discipline <em>(serek hayohad)</em></p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>1QS<sup>a</sup></em></p></td>
<td class="wid75"><p class="t-hang">Appendix A to <em>1QS</em> (“Rule of the Congregation”)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>1QS<sup>b</sup></em></p></td>
<td class="wid75"><p class="t-hang">Appendix B to <em>1QS</em> (“Words of Blessing”)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><a id="page_xi"><em>CD</em></a></p></td>
<td class="wid75"><p class="t-hang">Cairo Damascus Covenant (= <em>4QD<sup>a-g(h)</sup></em> and <em>6QD</em>)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>1QH</em></p></td>
<td class="wid75"><p class="t-hang">Psalms of Thanksgiving <em>(hodayot)</em></p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>1QM</em></p></td>
<td class="wid75"><p class="t-hang">War Scroll <em>(milhamah)</em></p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>1QIs<sup>a</sup></em></p></td>
<td class="wid75"><p class="t-hang">Isaiah Scroll, exemplar a (complete)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>1QpHab</em></p></td>
<td class="wid75"><p class="t-hang">Pesher Comments on Habakkuk 1 and 2</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>1QpMic</em></p></td>
<td class="wid75"><p class="t-hang">Pesher Comments on Micah</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>1QpPs</em></p></td>
<td class="wid75"><p class="t-hang">Pesher Comments on Psalms</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>1QpZeph</em></p></td>
<td class="wid75"><p class="t-hang">Pesher Comments on Zephaniah</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>1QapGen</em></p></td>
<td class="wid75"><p class="t-hang">Genesis Apocryphon</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>4QTes</em></p></td>
<td class="wid75"><p class="t-hang">Testimonia Fragment</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>4QFlor</em></p></td>
<td class="wid75"><p class="t-hang">Florilegium Fragment</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>4QPatr</em></p></td>
<td class="wid75"><p class="t-hang">Patriarchal Blessings</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>4QDeut</em></p></td>
<td class="wid75"><p class="t-hang">Deuteronomy Scroll</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>4QpGen<sup>a</sup></em></p></td>
<td class="wid75"><p class="t-hang">Pesher Comments on Genesis</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>4QpIsa<sup>a-e</sup></em></p></td>
<td class="wid75"><p class="t-hang">Pesher Comments on Isaiah</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>4QpHos<sup>a, b</sup></em></p></td>
<td class="wid75"><p class="t-hang">Pesher Comments on Hosea</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>4QpNah</em></p></td>
<td class="wid75"><p class="t-hang">Pesher Comments on Nahum</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>4QpPs<sup>a, b</sup></em></p></td>
<td class="wid75"><p class="t-hang">Pesher Comments on Psalms</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>4QSir</em></p></td>
<td class="wid75"><p class="t-hang">Serek Sirot ‘Olat Hassabbat</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>4QMMT</em></p></td>
<td class="wid75"><p class="t-hang">Miq<span class="charis">ṣ</span>at Ma‘ase Tõrah (“Works of the Law”)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>4QtgLev</em></p></td>
<td class="wid75"><p class="t-hang">Targum of Leviticus</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>4QtgJob</em></p></td>
<td class="wid75"><p class="t-hang">Targum of Job</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>4QPBless</em></p></td>
<td class="wid75"><p class="t-hang">Patriarchal Blessings</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>11QMelch</em></p></td>
<td class="wid75"><p class="t-hang">Melchizedek Scroll</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>11QTemple</em></p></td>
<td class="wid75"><p class="t-hang">Temple Scroll</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>11QtgJob</em></p></td>
<td class="wid75"><p class="t-hang">Targum of Job</p></td>
</tr>
</tbody>
</table>
<p class="tabtitle">Rabbinic Literature</p>
<p class="paras"><em>Mish</em> refers to the Mishnah; the letters <em>b</em> and <em>j</em> signal the Babylonian Talmud <em>(Talmud babli)</em> and Palestinian Talmud (<em>Talmud jerusalmi</em>), respectively; <em>R</em> signifies either Rabbah in the Midrashim or Rabbi; and <em>Tos</em> indicates the Tosephta. Tractates cited from the Mishnah, Babylonian Gemaras, Palestinian Gemaras, and Tosephta are abbreviated as follows:</p>
<table>
<tbody>
<tr>
<td class="wid20"><p class="t-hang"><em>Ber</em></p></td>
<td class="wid75"><p class="t-hang"><em>Berakoth</em> (“Benedictions”)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>Shab</em></p></td>
<td class="wid75"><p class="t-hang"><em>Shabbath</em> (“Sabbath”)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>Erub</em></p></td>
<td class="wid75"><p class="t-hang"><em>Erubin</em> (“Fusion of Sabbath Limits”)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>Pes</em></p></td>
<td class="wid75"><p class="t-hang"><em>Pesahim</em> (“Feast of Passover”)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>Yoma</em></p></td>
<td class="wid75"><p class="t-hang"><em>Yoma</em> (“Day of Atonement”)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>Suk</em></p></td>
<td class="wid75"><p class="t-hang"><em>Sukkah</em> (“Feast of Tabernacles”)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>Rosh</em></p></td>
<td class="wid75"><p class="t-hang"><em>Rosh ha-Shanah</em> (“Feast of the New Year”)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>Meg</em></p></td>
<td class="wid75"><p class="t-hang"><em>Megillah</em> (“Scroll of Esther”)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>Hag</em></p></td>
<td class="wid75"><p class="t-hang"><em>Hagigah</em> (“Festal Offering”)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>Yeb</em></p></td>
<td class="wid75"><p class="t-hang"><em>Yebamoth</em> (“Sisters-in-Law”)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><a id="page_xii"><em>Ned</em></a></p></td>
<td class="wid75"><p class="t-hang"><em>Nedarim</em> (“Vows”)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>Kidd</em></p></td>
<td class="wid75"><p class="t-hang"><em>Kiddushin</em> (“Betrothals”)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>Sanh</em></p></td>
<td class="wid75"><p class="t-hang"><em>Sanhedrin</em> (“Sanhedrin”)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>Mak</em></p></td>
<td class="wid75"><p class="t-hang"><em>Makkoth</em> (“Stripes”)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>Abod</em></p></td>
<td class="wid75"><p class="t-hang"><em>Abodah Zarah</em> (“Idolatry”)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>Aboth</em></p></td>
<td class="wid75"><p class="t-hang"><em>Pirke Aboth</em> (“Sayings of the Fathers”)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>Hor</em></p></td>
<td class="wid75"><p class="t-hang"><em>Horayoth</em> (“Instructions”)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>Hul</em></p></td>
<td class="wid75"><p class="t-hang"><em>Hullin</em> (“Animals Killed for Food”)</p></td>
</tr>
<tr>
<td class="wid20"><p class="t-hang"><em>Ker</em></p></td>
<td class="wid75"><p class="t-hang"><em>Kerithoth</em> (“Extirpation”)</p></td>
</tr>
</tbody>
</table>
<p class="paras">All other abbreviations are customary or self-explanatory.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005_Abbreviations.vue?816d27ac